import OrderAction from './orderAction';
import Order from '../models/orderModel';
import DeleteRefundRequestActionAttendee from '../../../pages/attendee/actions/deleteRefundRequestAction';
import DeleteRefundRequestPostAction from '../post-action/deleteRefundRequestPostAction';

export default class DeleteRefundRequestAction extends OrderAction {
    static NAME = 'delete_refund_requests';
    static POST_ACTION_COMPONENT = DeleteRefundRequestPostAction;

    static condition(order) {
        if (!order.refund_requests || !order.refund_requests.length || !order.refund_requests.filter(rr => rr.removed === null).length) {
            return false;
        }
        return true;
    }

    static is_attendee_valid({ attendee, order }) {
        return DeleteRefundRequestActionAttendee.is_attendee_valid({ attendee, order });
    }

    static is_available({ mode }) {
        return mode === 'detail';
    }

    static is_disabled({ items }) {
        return !items.some(i => this.condition(i)) || items.length !== 1;
    }

    get needs_confirm() {
        return false;
    }

    get needs_selection() {
        return false;
    }

    get post_action() {
        return true;
    }

    runPostAction({ requests_to_delete }) {
        return Order.perform_action(this.constructor.NAME, requests_to_delete, { organization: this.organization, event: this.event });
    }

    get is_direct() {
        return true;
    }

    run() {
        return Promise.resolve(true);
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
